/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignCenter = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M17 12H7" }],
    ["path", { d: "M19 18H5" }],
    ["path", { d: "M21 6H3" }]
  ]
];

export { AlignCenter as default };
//# sourceMappingURL=align-center.js.map
